class Audio {
  constructor() {
    Audio.init();
  }

  static init() {
    [].forEach.call(window.wrapper.querySelectorAll('.js-audio'), (block) => {
      const button = block.querySelector('.button--audio');
      /** @type {HTMLAudioElement} */
      const audio = block.querySelector('audio');
      button.addEventListener('mouseenter', () => window.cursor.enter(false, false));
      button.addEventListener('mouseleave', () => window.cursor.leave());
      button.addEventListener('click', () => {
        audio[audio.paused  ? 'play' : 'pause']();
        block.classList.toggle('js-audio--playing', !audio.paused)
      });
      audio.addEventListener('ended', () => {
        block.classList.remove('js-audio--playing');
      })
    });
  }
}

export default Audio;
